import request from '@/apis/base.js'
//根据编码查询土地详细信息
export function getLandInfoDetailByCode(param) {
    return request({
        url: '/multipleRules/getLandInfoDetailByCode',
        method: 'get',
        params: param
    })
}